/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Aiflowcostpillnobalance5Inputs */

const en_aiflowcostpillnobalance5 = /** @type {(inputs: Aiflowcostpillnobalance5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cost ${i?.cost} credits`)
};

const de_aiflowcostpillnobalance5 = /** @type {(inputs: Aiflowcostpillnobalance5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kosten ${i?.cost} Credits`)
};

/**
* | output |
* | --- |
* | "Cost {cost} credits" |
*
* @param {Aiflowcostpillnobalance5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowcostpillnobalance5 = /** @type {((inputs: Aiflowcostpillnobalance5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowcostpillnobalance5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowcostpillnobalance5(inputs)
	return de_aiflowcostpillnobalance5(inputs)
});
export { aiflowcostpillnobalance5 as "aiFlowCostPillNoBalance" }